import { matchPath } from "react-router-dom";

import { LOCALE_PARAM } from "@/constants/routes";

import { isSupportedLanguage } from "./isSupportedLanguage";

export function detectLocaleFromUrl(): string | null {
  const path = window.location.pathname;
  const localeMatch = matchPath({ path: `/:${LOCALE_PARAM}/*` }, path);

  const locale = localeMatch?.params?.[LOCALE_PARAM];

  if (locale && isSupportedLanguage(locale)) {
    return locale;
  }

  return null;
}
